export default {
    isAuthenticated(state) {
        return !!state.user.token;
    },
    userId(state) {
        return state.user.userId;
    },
};